import styled from "styled-components";

export const CardInputWrapper = styled.div`
    width: 100%;
    margin-bottom: 20px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: white;

    .StripeElement {
        width: 100%;
        font-size: 16px;
        color: #333;
    }
`;
